/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../compat/compat.module';
import * as i2 from '../../compat/compat.component';
import * as i3 from '../app/@shared/tracking/tracking.component.ngfactory';
import * as i4 from './compat.component.ngfactory';
import * as i5 from '@angular/common';
import * as i6 from '@angular/platform-browser';
import * as i7 from '@angular/animations/browser';
import * as i8 from '@angular/platform-browser/animations';
import * as i9 from '@angular/animations';
import * as i10 from '@angular/http';
import * as i11 from '../../app/@shared/tracking/tracking.module';
import * as i12 from '@ngrx/store-devtools/src/extension';
import * as i13 from '@ngrx/store-devtools/src/instrument';
import * as i14 from '@ngrx/store-devtools/src/devtools';
import * as i15 from '@ngrx/store/src/dispatcher';
import * as i16 from '@ngrx/store/src/ng2';
import * as i17 from '@ngrx/store/src/reducer';
import * as i18 from '@ngrx/store-devtools/src/config';
import * as i19 from '@ngrx/store/src/state';
import * as i20 from '@ngrx/store/src/store';
import * as i21 from '../../app/@shared/datastore/api-http.service';
import * as i22 from '../../app/@shared/auth/auth.service';
import * as i23 from '../../app/@shared/datastore/datastore.config';
import * as i24 from '../../app/@shared/datastore/store';
import * as i25 from '../../app/@shared/datastore/websocket/websocket';
import * as i26 from '../../app/@shared/datastore/datastore';
import * as i27 from '../../app/@shared/tracking/tracking.service';
import * as i28 from 'ngx-cookie/src/cookie.service';
import * as i29 from '../../app/@shared/tracking/tracking.config';
import * as i30 from '../../app/@shared/auth/auth.config';
import * as i31 from 'ngx-cookie/src/cookie-options-provider';
import * as i32 from 'ngx-cookie/src/cookie.factory';
import * as i33 from '../../app/@shared/tracking/error-tracking.service';
import * as i34 from '../../app/@shared/tracking/custom-error-handler.service';
import * as i35 from 'ngx-cookie/index';
import * as i36 from '../../app/@shared/auth/auth.module';
import * as i37 from '../../app/@shared/datastore/datastore.module';
import * as i38 from '@angular/router';
import * as i39 from '../../app/@shared/tracking/tracking.component';
import * as i40 from '../../compat/compat-navigation.component';
export const CompatModuleNgFactory:i0.NgModuleFactory<i1.CompatModule> = i0.ɵcmf(i1.CompatModule,
    [i2.CompatComponent],(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i3.TrackingComponentNgFactory,i4.CompatComponentNgFactory]],[3,i0.ComponentFactoryResolver],
              i0.NgModuleRef]),i0.ɵmpd(5120,i0.LOCALE_ID,i0.ɵm,[[3,i0.LOCALE_ID]]),
          i0.ɵmpd(4608,i5.NgLocalization,i5.NgLocaleLocalization,[i0.LOCALE_ID]),i0.ɵmpd(4608,
              i0.Compiler,i0.Compiler,([] as any[])),i0.ɵmpd(5120,i0.APP_ID,i0.ɵf,
              ([] as any[])),i0.ɵmpd(5120,i0.IterableDiffers,i0.ɵk,([] as any[])),
          i0.ɵmpd(5120,i0.KeyValueDiffers,i0.ɵl,([] as any[])),i0.ɵmpd(4608,i6.DomSanitizer,
              i6.ɵe,[i6.DOCUMENT]),i0.ɵmpd(6144,i0.Sanitizer,(null as any),[i6.DomSanitizer]),
          i0.ɵmpd(4608,i6.HAMMER_GESTURE_CONFIG,i6.HammerGestureConfig,([] as any[])),
          i0.ɵmpd(5120,i6.EVENT_MANAGER_PLUGINS,(p0_0:any,p1_0:any,p2_0:any,p2_1:any) => {
            return [new i6.ɵDomEventsPlugin(p0_0),new i6.ɵKeyEventsPlugin(p1_0),new i6.ɵHammerGesturesPlugin(p2_0,
                p2_1)];
          },[i6.DOCUMENT,i6.DOCUMENT,i6.DOCUMENT,i6.HAMMER_GESTURE_CONFIG]),i0.ɵmpd(4608,
              i6.EventManager,i6.EventManager,[i6.EVENT_MANAGER_PLUGINS,i0.NgZone]),
          i0.ɵmpd(135680,i6.ɵDomSharedStylesHost,i6.ɵDomSharedStylesHost,[i6.DOCUMENT]),
          i0.ɵmpd(4608,i6.ɵDomRendererFactory2,i6.ɵDomRendererFactory2,[i6.EventManager,
              i6.ɵDomSharedStylesHost]),i0.ɵmpd(5120,i7.AnimationDriver,i8.ɵc,([] as any[])),
          i0.ɵmpd(5120,i7.ɵAnimationStyleNormalizer,i8.ɵd,([] as any[])),i0.ɵmpd(4608,
              i7.ɵAnimationEngine,i8.ɵb,[i7.AnimationDriver,i7.ɵAnimationStyleNormalizer]),
          i0.ɵmpd(5120,i0.RendererFactory2,i8.ɵe,[i6.ɵDomRendererFactory2,i7.ɵAnimationEngine,
              i0.NgZone]),i0.ɵmpd(6144,i6.ɵSharedStylesHost,(null as any),[i6.ɵDomSharedStylesHost]),
          i0.ɵmpd(4608,i0.Testability,i0.Testability,[i0.NgZone]),i0.ɵmpd(4608,i6.Meta,
              i6.Meta,[i6.DOCUMENT]),i0.ɵmpd(4608,i6.Title,i6.Title,[i6.DOCUMENT]),
          i0.ɵmpd(4608,i9.AnimationBuilder,i8.ɵBrowserAnimationBuilder,[i0.RendererFactory2]),
          i0.ɵmpd(4608,i10.BrowserXhr,i10.BrowserXhr,([] as any[])),i0.ɵmpd(4608,i10.ResponseOptions,
              i10.BaseResponseOptions,([] as any[])),i0.ɵmpd(4608,i10.XSRFStrategy,
              i11.NoXSRFStrategy,([] as any[])),i0.ɵmpd(4608,i10.XHRBackend,i10.XHRBackend,
              [i10.BrowserXhr,i10.ResponseOptions,i10.XSRFStrategy]),i0.ɵmpd(4608,
              i10.RequestOptions,i10.BaseRequestOptions,([] as any[])),i0.ɵmpd(5120,
              i10.Http,i10.ɵc,[i10.XHRBackend,i10.RequestOptions]),i0.ɵmpd(5120,i12.REDUX_DEVTOOLS_EXTENSION,
              i13._createReduxDevtoolsExtension,([] as any[])),i0.ɵmpd(4608,i12.DevtoolsExtension,
              i12.DevtoolsExtension,[i12.REDUX_DEVTOOLS_EXTENSION]),i0.ɵmpd(4608,i14.DevtoolsDispatcher,
              i14.DevtoolsDispatcher,([] as any[])),i0.ɵmpd(4608,i15.Dispatcher,i15.Dispatcher,
              ([] as any[])),i0.ɵmpd(5120,i16.INITIAL_REDUCER,i16._initialReducerFactory,
              [i16._INITIAL_REDUCER]),i0.ɵmpd(5120,i17.Reducer,i13._createReducerIfExtension,
              [i12.REDUX_DEVTOOLS_EXTENSION,i0.Injector,i16.INITIAL_REDUCER]),i0.ɵmpd(5120,
              i16.INITIAL_STATE,i16._initialStateFactory,[i16._INITIAL_STATE,i16.INITIAL_REDUCER]),
          i0.ɵmpd(5120,i18.STORE_DEVTOOLS_CONFIG,i13._createOptions,[i18.INITIAL_OPTIONS]),
          i0.ɵmpd(4608,i14.StoreDevtools,i14.StoreDevtools,[i14.DevtoolsDispatcher,
              i15.Dispatcher,i17.Reducer,i12.DevtoolsExtension,i16.INITIAL_STATE,i18.STORE_DEVTOOLS_CONFIG]),
          i0.ɵmpd(5120,i19.State,i13._createStateIfExtension,[i12.REDUX_DEVTOOLS_EXTENSION,
              i0.Injector,i16.INITIAL_STATE]),i0.ɵmpd(5120,i20.Store,i16._storeFactory,
              [i15.Dispatcher,i17.Reducer,i19.State]),i0.ɵmpd(4608,i21.ApiHttp,i21.ApiHttp,
              [i10.XHRBackend,i10.RequestOptions,i22.Auth,i23.DATASTORE_CONFIG]),i0.ɵmpd(5120,
              i24.Store,i16._storeFactory,[i15.Dispatcher,i17.Reducer,i19.State]),
          i0.ɵmpd(4608,i25.WebSocketService,i25.WebSocketService,[i23.DATASTORE_CONFIG,
              i22.Auth,i24.Store]),i0.ɵmpd(4608,i26.Datastore,i26.Datastore,[i24.Store,
              i21.ApiHttp,i25.WebSocketService]),i0.ɵmpd(4608,i27.Tracking,i27.Tracking,
              [i10.Http,i22.Auth,i28.CookieService,i29.TRACKING_CONFIG]),i0.ɵmpd(4608,
              i0.NgModuleFactoryLoader,i0.SystemJsNgModuleLoader,[i0.Compiler,[2,i0.SystemJsNgModuleLoaderConfig]]),
          i0.ɵmpd(512,i5.CommonModule,i5.CommonModule,([] as any[])),i0.ɵmpd(256,i30.AUTH_CONFIG,
              {baseUrl:'https://www.freelancer.com/auth',authHashCookie:'GETAFREE_AUTH_HASH_V2',
                  userIdCookie:'GETAFREE_USER_ID'},([] as any[])),i0.ɵmpd(256,i31.COOKIE_OPTIONS,
              {},([] as any[])),i0.ɵmpd(512,i31.CookieOptionsProvider,i31.CookieOptionsProvider,
              [i31.COOKIE_OPTIONS,i0.Injector]),i0.ɵmpd(1024,i28.CookieService,i32.cookieServiceFactory,
              [i31.CookieOptionsProvider]),i0.ɵmpd(512,i22.Auth,i22.Auth,[i30.AUTH_CONFIG,
              i28.CookieService]),i0.ɵmpd(256,i29.TRACKING_CONFIG,{trackingEndpoint:'https://t.freelancer.com/0px.gif',
              sessionCookie:'_tracking_session',navigationPerformanceSamplingRate:1,
              enableErrorTracking:true,sentryDsn:'https://89961363a0f642558f5fedad5195eb89@sentry.io/85230',
              gitRevision:'99ef035f96d',buildDate:'Tue Jul 11 2017 08:58:34 GMT-0400 (EDT)'},
              ([] as any[])),i0.ɵmpd(512,i33.ErrorTracking,i33.ErrorTracking,[i22.Auth,
              i29.TRACKING_CONFIG]),i0.ɵmpd(512,i0.ErrorHandler,i34.CustomErrorHandler,
              [i33.ErrorTracking]),i0.ɵmpd(1024,i0.APP_INITIALIZER,(p0_0:any,p0_1:any) => {
            return [i6.ɵc(p0_0,p0_1)];
          },[[2,i6.NgProbeToken],[2,i0.NgProbeToken]]),i0.ɵmpd(512,i0.ApplicationInitStatus,
              i0.ApplicationInitStatus,[[2,i0.APP_INITIALIZER]]),i0.ɵmpd(131584,i0.ɵe,
              i0.ɵe,[i0.NgZone,i0.ɵConsole,i0.Injector,i0.ErrorHandler,i0.ComponentFactoryResolver,
                  i0.ApplicationInitStatus]),i0.ɵmpd(2048,i0.ApplicationRef,(null as any),
              [i0.ɵe]),i0.ɵmpd(512,i0.ApplicationModule,i0.ApplicationModule,[i0.ApplicationRef]),
          i0.ɵmpd(512,i6.BrowserModule,i6.BrowserModule,[[3,i6.BrowserModule]]),i0.ɵmpd(512,
              i8.BrowserAnimationsModule,i8.BrowserAnimationsModule,([] as any[])),
          i0.ɵmpd(512,i35.CookieModule,i35.CookieModule,([] as any[])),i0.ɵmpd(512,
              i36.AuthModule,i36.AuthModule,([] as any[])),i0.ɵmpd(512,i10.HttpModule,
              i10.HttpModule,([] as any[])),i0.ɵmpd(512,i16.StoreModule,i16.StoreModule,
              ([] as any[])),i0.ɵmpd(512,i13.StoreDevtoolsModule,i13.StoreDevtoolsModule,
              ([] as any[])),i0.ɵmpd(512,i37.DatastoreModule,i37.DatastoreModule,([] as any[])),
          i0.ɵmpd(512,i11.TrackingModule,i11.TrackingModule,([] as any[])),i0.ɵmpd(512,
              i1.CompatModule,i1.CompatModule,([] as any[])),i0.ɵmpd(256,i16._INITIAL_REDUCER,
              i24.store,([] as any[])),i0.ɵmpd(256,i16._INITIAL_STATE,(undefined as any),
              ([] as any[])),i0.ɵmpd(256,i18.INITIAL_OPTIONS,{maxAge:5},([] as any[])),
          i0.ɵmpd(256,i23.DATASTORE_CONFIG,{apiBaseUrl:'https://www.freelancer.com/api',
              ajaxBaseUrl:'https://www.freelancer.com/ajax-api',webSocketUrl:'https://notifications.freelancer.com'},
              ([] as any[])),i0.ɵmpd(1024,i38.ROUTES,() => {
            return [[{selector:'webapp-compat-tracking',loadChildren:'app/@shared/tracking/tracking.module#TrackingModule',
                component:i39.TrackingComponent,path:'hack_path_not_used'},{selector:'webapp-compat-navigation',
                loadChildren:'compat/compat-navigation.module#CompatNavigationModule',
                component:i40.CompatNavigationComponent,path:'hack_path_not_used'}]];
          },([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkL3dlYmFwcC9zcmMvY29tcGF0L2NvbXBhdC5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQvd2ViYXBwL3NyYy9jb21wYXQvY29tcGF0Lm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build/webapp/src/$$_gendir/compat/compat.module.ngfactory.ts